import api from '../api';

/**
 * Update the status of a table based on the table code.
 *
 * @param {string} tableCode - The code of the table to update.
 * @param {string} newStatus - The new status to set for the table.


 * @param {number} duration - The duration for the table.
 * @return {Promise<Object>} - The response from the API.
 * @throws {Error} - If the request fails.
 */
const updateTableStatus = async (storeCode,tableCode, newStatus,duration,) => {
  const endpoint = `${process.env.REACT_APP_API_ENDPOINT}/api/table/updateStatus`;

  try {
    const response = await api.post(endpoint, {
      store_code:storeCode,
      table_code: tableCode,
      status: newStatus,
      duration:duration,
    });
    return response.data;
  } catch (error) {
    console.error('Error updating table status:', error);
    throw error;
  }
}

export default updateTableStatus;
